<template>
  <div id="wrap">
    <div class="dashboard clear">
      <Toolbar :menuInfo="menuInfo"></Toolbar>
      <div class="right">
        <Navigation :menuInfo="menuInfo"></Navigation>
        <div class="main">
          <div class="main-nav">
            <ContentsNavigation v-if="false && (menuInfo.company || menuInfo.device)" :menuInfo="menuInfo" @selectNode="selectNode"></ContentsNavigation>
          </div>
          <div class="board clear">
            <TreeView
              :treeType="treeType"
              :treeScope="treeScope"
              :refreshEvent="refreshEvent"
              @selectNode="selectNode"
            ></TreeView>
            <div
              v-if="viewType === 'productList'"
              class="list"
            >
              <ProductList
                v-if="viewType === 'productList'"
                :company="company"
                :searchCondition="searchCondition"
                :startTime="startTime"
                :endTime="endTime"
                :searchEvent="selectEvent"
                @productDetail="productDetail"
                @productCreate="productCreate"
              ></ProductList>
            </div>
            <div
              v-else-if="viewType === 'productDetail'"
              class="detail">
              <ProductDetail
                v-if="viewType === 'productDetail'"
                :product="product"
                @refreshList="selectNode"
              ></ProductDetail>
            </div>
            <div
              v-else-if="viewType === 'productCreate'"
              class="create">
              <ProductCreate
                v-if="viewType === 'productCreate'"
                :company="company"
                @refreshList="selectNode"
              ></ProductCreate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-bitwise */

import Toolbar from '@/components/include/Toolbar';
import Navigation from '@/components/include/Navigation';
import ContentsNavigation from '@/components/include/ContentsNavigation';
import TreeView from '@/components/include/TreeView';
import ProductList from '@/components/product/ProductList';
import ProductDetail from '@/components/product/ProductDetail';
import ProductCreate from '@/components/product/ProductCreate';

export default {
  components: {
    Toolbar,
    Navigation,
    ContentsNavigation,
    ProductList,
    ProductDetail,
    ProductCreate,
    TreeView,
  },
  data: () => ({
    menu: null,
    treeType: 'company',
    treeScope: 'biz',
    viewType: 'productList',
    company: null,
    product: null,
    selectEvent: 0,
    refreshEvent: 0,
    searchCondition: null,
    startTime: '',
    endTime: '',
    menuInfo: {
      mainTitle: 'Device',
      mainName: '재고 관리',
      subTitle: 'Product',
      subName: '상품 관리',
      company: null,
      division: null,
      device: null,
      tray: null,
      product: null,
    },
  }),
  created() {
    this.menu = this.$route.name;
  },
  methods: {
    selectNode(object, type, isTreeRefresh) {
      if (type === 'company') {
        this.company = object;
        this.product = null;
        this.menuInfo.company = object;
        this.menuInfo.product = null;
        this.viewType = 'productList';
        this.selectEvent ^= 1;
      }

      if (isTreeRefresh) {
        this.refreshEvent ^= 1;
      }
    },
    productDetail(product) {
      this.company = null;
      this.product = product;
      this.menuInfo.company = null;
      this.menuInfo.product = product;
      this.viewType = 'productDetail';
      this.selectEvent ^= 1;
    },
    productCreate(company) {
      this.company = company;
      this.product = null;
      this.menuInfo.company = company;
      this.viewType = 'productCreate';
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/product/Product.vue